import { useState } from "react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "./ui/select";
import { Input } from "./ui/input";
import { Search } from "lucide-react";

const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const LocationSelect = ({ value, onChange, groups = [], placeholder = "—", allLabel, testId, className }) => {
  const [q, setQ] = useState("");
  const nq = norm(q);
  const filtered = nq
    ? groups.map((g) => ({ region: g.region, cities: g.cities.filter((c) => norm(c).includes(nq)) })).filter((g) => g.cities.length)
    : groups;

  const handleChange = (v) => { onChange(v); setQ(""); };

  return (
    <Select value={value} onValueChange={handleChange}>
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-80">
        <div className="sticky top-0 z-10 bg-popover p-2 -mx-1 -mt-1 border-b border-border">
          <div className="relative">
            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              placeholder="Rechercher une ville…"
              data-testid={testId ? `${testId}-search` : undefined}
              className="h-9 pl-8"
            />
          </div>
        </div>
        {allLabel && !nq && <SelectItem value="all">{allLabel}</SelectItem>}
        {filtered.map((g) => (
          <SelectGroup key={g.region}>
            <SelectLabel className="text-primary/80">{g.region}</SelectLabel>
            {g.cities.map((c) => (
              <SelectItem key={c} value={c}>{c}</SelectItem>
            ))}
          </SelectGroup>
        ))}
        {filtered.length === 0 && (
          <div className="px-3 py-6 text-center text-sm text-muted-foreground">Aucune ville trouvée</div>
        )}
      </SelectContent>
    </Select>
  );
};
